<template>
  <div>
    <load-profile />
    <b-tabs
      v-model="activeTab"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
      @input="handleTabChange"
    >
      <b-tab
        v-if="$can('manage', permissionType)"
        lazy
      >
        <template #title>
          <feather-icon
            icon="UsersIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.employee')
          }}</span>
        </template>
        <employee-list
          :team-id="$route.params.teamId"
          :department-id="$route.params.departmentId"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTab, BTabs,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import EmployeeList from './EmployeeList.vue'

const TeamRepository = Repository.get('team')
const DepartmentRepository = Repository.get('department')

export default {
  name: 'Employee',
  components: {
    BTab,
    BTabs,
    EmployeeList,
  },

  data() {
    return {
      activeTab: 0,
      permissionType: 'manage-employee',
      tabMapping: {
        employee: 0,
      },
    }
  },

  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(newTab) {
        if (newTab && this.tabMapping[newTab] !== undefined) {
          this.activeTab = this.tabMapping[newTab]
          this.updateBreadcrumb()
        }
      },
    },
  },

  created() {
    const { tab } = this.$route.query
    if (tab && this.tabMapping[tab] !== undefined) {
      this.activeTab = this.tabMapping[tab]
    }
  },

  methods: {
    handleTabChange(newTab) {
      const tabNames = Object.keys(this.tabMapping)
      const newTabName = tabNames.find(key => this.tabMapping[key] === newTab)

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          tab: newTabName,
        },
      })

      this.updateBreadcrumb()
    },

    updateBreadcrumb() {
      const breadcrumbText = 'breadcrumb.employee'

      if (this.$route.meta.breadcrumb && this.$route.meta.breadcrumb.length > 0) {
        this.$route.meta.breadcrumb[this.$route.meta.breadcrumb.length - 1] = {
          text: breadcrumbText,
          active: true,
        }
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    if (!to.params.teamId && !to.params.departmentId) {
      return next()
    }

    try {
      const response = await TeamRepository.show(to.params.teamId)
      const data = response?.data?.data
      if (!data || !data.id) {
        // If no data or invalid data, redirect back to department list
        return next({ name: 'list-department' })
      }

      const getNameByLang = data => {
        const locale = localStorage.getItem('locale') || 'en'
        return data.name?.[locale] || data.name?.zh || data.name?.en || data.name?.km || data.name?.vi || ''
      }

      const departmentResponse = await DepartmentRepository.show(to.params.departmentId)
      const departmentData = departmentResponse?.data?.data
      if (!departmentData || !departmentData.id) {
        return next({ name: 'list-department' })
      }

      // Set breadcrumb if data exists
      to.meta.breadcrumb = [
        {
          text: typeof departmentData?.name === 'object' ? getNameByLang(departmentData) : departmentData?.name,
          to: { name: 'list-department' },
        },
        {
          text: getNameByLang(data),
          to: { name: 'list-team' },
        },
        {
          text: 'breadcrumb.employee',
          active: true,
        },
      ]

      next()
    } catch (error) {
      // Handle any errors by redirecting to department list
      console.error('Failed to fetch department:', error)
      next({ name: 'list-team' })
    }
  },
}
</script>
